<p-treeTable
    #tree
    [loading]="loadingTreeNodes"
    [value]="treeNodes"
    [columns]="treeColumns"
    dataKey="id"
    [contextMenu]="cm"
    contextMenuSelectionMode="joint"
    [scrollable]="true"
    scrollHeight="700px"
    [selectionMode]="this.selectionMode"
    [(selection)]="this.selected"
    (onNodeUnselect)="unselectNode()"
    (onNodeSelect)="selectNode()"
    [ngStyle]="{
        textAlign: 'left'
    }"

>
    <ng-template pTemplate="caption">
        <input
            type="text"
            pInputText
            placeholder="Search..."
            (input)="tree.filterGlobal($event.target.value, 'contains')"
            (keyup.enter)="transferOnEnter()"
            class="search-accounts-input"
            [(ngModel)]="searchValue"
        />
        <p-toggleButton
            *ngIf="showHideShowHierarchyButton && !disableHierarchyButton"
            offLabel=""
            onLabel=""
            offIcon="pi pi-list"
            onIcon="pi pi-sitemap"
            [(ngModel)]="toggleLeavesOnly"
            (onChange)="changeToggleLeavesOnly()"
            class="hierarchy-toggler"
        ></p-toggleButton>
    </ng-template>

    <ng-template
        pTemplate="header"
        *ngIf="treeColumns && treeColumns.length > 1"
    >
        <tr>
            <th *ngFor="let col of treeColumns" [style.width]="col.width">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
            <td
                *ngFor="let col of treeColumns; let i = index"
                style="word-wrap: break-word"
                [style.width]="col.width"
                [ngStyle]="{
                    fontWeight: rowData.leaf ? 'inherit' : '600'
                }"
            >
            <div *ngIf="col.header !== 'Row #'">
                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
                {{ rowData[col.field] }}
            </div>

            <!-- Condition for when the header is 'Row #' -->
            <div *ngIf="col.header === 'Row #'">
                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>

                <span *ngFor="let colValue of rowData.lineNumbers; let j = index"
                    title="Go to report line {{ colValue }}"
                    class="clickable"
                    (click)="this.goToReportLine(colValue)">
                    {{ colValue }}
                </span>
            </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="treeColumns.length">No data found.</td>
        </tr>
    </ng-template>
</p-treeTable>
<p-contextMenu #cm [model]="items" appendTo="body"></p-contextMenu>
